import { Navigate } from "react-router-dom";
import { useAuthContext } from "../contexts/AuthContext";
import ProfileCompletionGuard from "./ProfileCompletionGuard";
import EmailVerificationGuard from "./EmailVerificationGuard";

export default function ProtectedRoute({ children }: { children: JSX.Element }) {
  const { user, loading } = useAuthContext();

  if (loading) return <div className="p-4 text-center">กำลังโหลด...</div>;
  if (!user) return <Navigate to="/login" />;

  return (
    <EmailVerificationGuard>
      <ProfileCompletionGuard>
        {children}
      </ProfileCompletionGuard>
    </EmailVerificationGuard>
  );
}
